import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textarea-inner" }
const _hoisted_2 = ["id", "placeholder", "maxlength", "rows"]

import {
  ref,
  onMounted,
  computed,
  watch,
  StyleValue,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CharCounterTextArea',
  props: {
    id: { default: "" },
    modelValue: { default: "" },
    maxlength: { default: 50 },
    resize: { default: "none" },
    width: { default: "100%" },
    maxWidth: { default: "100%" },
    height: { default: "100%" },
    minHeight: { default: "100px" },
    rows: { default: 5 },
    placeholder: { default: "" },
    customTextareaWrapper: { default: "custom-textarea-wrapper" },
    textareaClass: { default: "custom-textarea" },
    charCounterClass: { default: "char-counter" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const textareaRef = ref<HTMLTextAreaElement | null>(null);
const currentHeight = ref(props.height);
const userResized = ref(false);

const emit = __emit;
const text = computed({
  get: () => props.modelValue,
  set: (val: string) => emit("update:modelValue", val), // 親へ入力の更新を通知
});
onMounted(() => {
  if (textareaRef.value) {
    currentHeight.value =
      getComputedStyle(textareaRef.value).height || props.height;
  }
});
// リサイズ監視 ※監視対象は高さのみ
watch(
  () => props.height,
  (newHeight) => {
    if (!userResized.value) {
      // 親が高さを変えた場合のみ反映
      currentHeight.value = newHeight;
    }
  }
);
// 入力監視
const handleInput = (e: Event) => {
  const target = e.target as HTMLTextAreaElement;
  emit("update:modelValue", target.value); // 親へ入力の更新を通知
  if (!userResized.value && textareaRef.value) {
    currentHeight.value = getComputedStyle(textareaRef.value).height;
  }
};
// マウスアップ監視
const handleResizeEnd = () => {
  if (textareaRef.value) {
    const newHeight = getComputedStyle(textareaRef.value).height;
    currentHeight.value = newHeight;
    userResized.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.customTextareaWrapper])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("textarea", {
        ref_key: "textareaRef",
        ref: textareaRef,
        id: _ctx.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
        placeholder: _ctx.placeholder,
        maxlength: _ctx.maxlength,
        rows: _ctx.rows,
        class: _normalizeClass([_ctx.textareaClass]),
        style: _normalizeStyle({
          width: _ctx.width,
          height: currentHeight.value,
          minHeight: _ctx.minHeight,
          maxWidth: _ctx.maxWidth,
          resize: _ctx.resize,
        } as StyleValue),
        onInput: handleInput,
        onMouseup: handleResizeEnd
      }, null, 46, _hoisted_2), [
        [_vModelText, text.value]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.charCounterClass])
      }, _toDisplayString(text.value.length) + "/" + _toDisplayString(_ctx.maxlength), 3)
    ])
  ], 2))
}
}

})